"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const styled_components_1 = tslib_1.__importDefault(require("styled-components"));
const StyledFunctions_1 = require("../../helpers/StyledFunctions");
const ClickedOutside_1 = tslib_1.__importDefault(require("../ClickedOutside"));
const Toggle_1 = tslib_1.__importDefault(require("../Toggle"));
const Button_1 = tslib_1.__importDefault(require("./Button"));
const MenuWrapper_1 = tslib_1.__importDefault(require("./components/MenuWrapper"));
const defaultProps = {
    confirmButtonLabel: 'Confirm',
    cancelButtonLabel: 'Cancel',
};
const Container = (0, styled_components_1.default)('div') `
  position: relative;
`;
const ConfirmButton = ({ confirmButtonLabel, cancelButtonLabel, onConfirm, children, ...restProps }) => {
    const { elementTypes } = (0, StyledFunctions_1.extractElementType)(restProps);
    const { elementSizes } = (0, StyledFunctions_1.extractElementSize)(restProps);
    const { margins, paddings } = (0, StyledFunctions_1.extractMarginAndPadding)(restProps);
    return (react_1.default.createElement(Toggle_1.default, null, ({ isActive, toggle, off }) => {
        const handleConfirm = () => {
            if (onConfirm) {
                onConfirm();
            }
            off();
        };
        return (react_1.default.createElement(ClickedOutside_1.default, { shouldHandleClick: isActive, onClickOutside: off }, ({ ref }) => (react_1.default.createElement(Container, { ref: ref },
            react_1.default.createElement(Button_1.default, { ...elementSizes, ...elementTypes, ...margins, ...paddings, onClick: toggle }, children),
            isActive && (react_1.default.createElement(MenuWrapper_1.default, null,
                react_1.default.createElement(Button_1.default, { ...elementTypes, ...elementSizes, onClick: handleConfirm, marginRight: "0.5rem" }, confirmButtonLabel),
                react_1.default.createElement(Button_1.default, { ...elementSizes, secondary: true, outline: true, onClick: off }, cancelButtonLabel)))))));
    }));
};
ConfirmButton.defaultProps = defaultProps;
exports.default = ConfirmButton;
